const { default: CommonServices } = require("./common/common");

class NewsManagementService extends CommonServices {
  constructor() {
    super("/news");
  }
}

const newsManagementService = new NewsManagementService();
export default newsManagementService;
